import * as tslib_1 from "tslib";
import { listApi } from "@cloudpivot/api";
import AppsMenu from "@cloudpivot/application/src/components/pc/apps-menu.vue";
import common from "@cloudpivot/common";
import WorkflowCenterMenu from "@cloudpivot/flow-center/src/components/pc/menu/workflow-center-menu.vue";
import { Icon, Input, Layout, Popover, Tooltip, Tree, TreeSelect, Modal, } from "@h3/antd-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import SearchTree from "./components/search-tree.vue";
// 二开开始
import HomePage from "../../../../extends/views/Homepage/homepage.vue";
import axios from "axios";
//二开结束
const WorkflowCenterModule = namespace("WorkflowCenter/WorkflowCenter");
let Aside = class Aside extends Vue {
    constructor() {
        super(...arguments);
        // 侧边栏可拖拽初始宽度
        this.dragWidth = 200;
        this.startX = this.isAppList ? 250 : 200;
        // false 展开 true收起
        this.isShow = false;
        this.curMenu = "WorkflowCenterMenu";
        this.menuTitle = "流程中心";
        this.menuTitleI18n = {};
        this.isActive = false;
        this.treeShow = false;
        this.expandedKeys = [];
        this.searchValue = "";
        this.dataList = []; //搜索数据源
        this.autoExpandParent = true;
        this.AppList = [];
        this.defaultKey = []; //默认选中key
        this.routeKey = [];
        this.treeData = [];
        this.routeName = [];
        this.hasSearch = false;
        /**
         * 循环嵌套查找指定属性
         */
        this.isData = null;
        // 二开开始 TA表单查看权限
        this.isShowApproval = false;
        this.searchFocus = false;
        this.queryCode = "";
        this.isEmployeeGroup = false;
    }
    get appName() {
        return this.$store.state.WorkflowCenter.WorkflowCenter.appName;
    }
    get outwardType() {
        // 获取主题外观
        return this.$store.state.outwardType;
    }
    //判断是流程还是应用
    get isAppList() {
        return this.$store.state.WorkflowCenter.WorkflowCenter.isAppList;
    }
    getWidth(val) {
        this.dragWidth = val ? 250 : 240;
        this.isShow = false;
    }
    initAppData(val) {
        if (this.appValueChange) {
            this.getAppGroups();
            this.setAppChange(false);
        }
    }
    get appValueChange() {
        return this.$store.state.WorkflowCenter.WorkflowCenter.appChange;
    }
    // 判断当前是否是中文版本
    get isChinese() {
        return !(this.$i18n.locale && this.$i18n.locale === "en");
    }
    get rootAdmin() {
        return this.$store && this.$store.state.System.System.isRootAdmin;
    }
    searchChange(bool) {
        this.hasSearch = bool;
    }
    handler(val) {
        if (val.fullPath.includes("/workflow-center/start-workflow")) {
            this.isActive = true;
        }
        else {
            this.isActive = false;
        }
    }
    /**
     * 获取子节点数据
     */
    getChildrenTreeData(data) {
        let office = data.map((item) => {
            if (item.children) {
                item = {
                    icon: item.icon,
                    title: this.isChinese ? item.name : JSON.parse(item.name_i18n)["en"],
                    name: item.name,
                    name_i18n: item.name_i18n,
                    key: item.code,
                    children: this.getChildrenTreeData(item.children),
                    scopedSlots: { title: "title" },
                    appCode: item.appCode,
                    code: item.code,
                    parentId: item.parentId,
                    openMode: item.openMode,
                    pcUrl: item.pcUrl,
                    queryCode: item.queryCode,
                    type: item.type,
                    deleted: item.deleted,
                    id: item.id,
                    mobileAble: item.mobileAble,
                    mobileUrl: item.mobileUrl,
                    modelType: item.modelType,
                    pcAble: item.pcAble,
                    published: item.published,
                    sortKey: item.sortKey,
                };
                return item;
            }
            else {
                // if (item.scopedSlots) {
                //   delete item.scopedSlots;
                // }
                item = {
                    icon: item.icon,
                    title: this.isChinese
                        ? item.name
                        : JSON.parse(item.name_i18n)
                            ? JSON.parse(item.name_i18n)["en"]
                            : item.name,
                    name: item.name,
                    name_i18n: item.name_i18n,
                    key: item.code,
                    children: null,
                    scopedSlots: { title: "title" },
                    appCode: item.appCode,
                    code: item.code,
                    parentId: item.parentId,
                    openMode: item.openMode,
                    pcUrl: item.pcUrl,
                    queryCode: item.queryCode,
                    type: item.type,
                    deleted: item.deleted,
                    id: item.id,
                    mobileAble: item.mobileAble,
                    mobileUrl: item.mobileUrl,
                    modelType: item.modelType,
                    pcAble: item.pcAble,
                    published: item.published,
                    sortKey: item.sortKey,
                };
                return item;
            }
        });
        return office;
    }
    /**
     * 搜索应用
     */
    selectedKeys(data) {
        this.routeKey = [];
        this.findItem(this.AppList, data.key[0]);
        this.onSelect(data.key, data.e);
    }
    findItem(data, code) {
        let isData = null;
        let office = data.map((item) => {
            isData = null;
            if (item.children) {
                // item = {
                //   children: this.findItem(item.children,code),
                //   ...item
                // }
                // return item;
                isData = this.findItem(item.children, code);
                if (isData) {
                    // this.routeKey.push(item.code)
                    this.routeKey.unshift(item.code);
                    this.routeName.unshift((this.isChinese
                        ? item.name
                        : (JSON.parse(item.name_i18n) &&
                            JSON.parse(item.name_i18n)["en"]) ||
                            item.name) || item.title);
                }
                return isData;
            }
            else {
                if (item.code === code) {
                    this.isData = item;
                    isData = item;
                    // } else if(item.type === 'Page' && item.pcUrl && item.pcUrl.indexOf(code) > -1){
                    //   this.isData = item;
                    //   isData = item;
                }
                // item = {
                //   children:null,
                //   ...item,
                // }
                // return item;
                if (isData) {
                    // this.routeKey.push(item.code)
                    this.routeKey.unshift(item.code);
                    this.routeName.unshift((this.isChinese
                        ? item.name
                        : (JSON.parse(item.name_i18n) &&
                            JSON.parse(item.name_i18n)["en"]) ||
                            item.name) || item.title);
                }
                return isData;
            }
        });
        for (const i of office) {
            if (i) {
                isData = office;
                return isData;
            }
        }
        return null;
    }
    getApprover(params) {
        return axios.get('/api/TA/getApprover', { params });
    }
    getIsApprover() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let userInfo = JSON.parse(window.sessionStorage.getItem('user'));
            const params = {
                deptName: userInfo.departmentName,
            };
            const res = yield this.getApprover(params);
            debugger;
            if (res.errcode === 0 && res.data && res.data.id) {
                if (res.data.id === userInfo.id) {
                    this.isShowApproval = true;
                }
                else {
                    this.isShowApproval = false;
                }
            }
            else {
                this.isShowApproval = false;
            }
        });
    }
    // 二开结束 TA表单查看权限
    // 二开 获取contract左侧目录树权限
    getContractTaskListByRole() {
        return axios.get('/api/contract/getContractTaskListByRole');
    }
    // 二开结束
    /**
     * 获取侧边栏树
     */
    getAppGroups() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('this.appCodethis.appCode', this.appCode);
            this.getIsApprover();
            const params = {
                appCode: this.appCode,
                isMobile: false,
            };
            // 二开 获取本地存储数据
            let user = JSON.parse(sessionStorage.getItem('user'));
            let userRole = user.roleName;
            let userRoleName = userRole && userRole.split(',') || [];
            // 二开 end
            const res = yield listApi.getFolder(params);
            if (res.errcode === 0) {
                // 二开 mobility faclity权限放开普通用户可在移动端提交表单PC端做隐藏
                if (this.appCode === 'mobility_faclity') {
                    if (user.username !== 'admin') {
                        if (!user.admin) {
                            if (!userRole) {
                                res.data = [];
                            }
                            else {
                                if (userRoleName.includes('PA Manager')) {
                                    res.data.forEach((item, index) => {
                                        if (item.name === "Setting") {
                                            item.children.splice(3, 4);
                                        }
                                    });
                                    console.log('PA Manager');
                                }
                                else if (userRoleName.includes('Mobility Officer') && userRoleName.includes('Facility Suppervisor')) {
                                    // return;
                                    res.data.forEach((item, index) => {
                                        if (item.name === "Setting") {
                                            item.children.splice(3, 4);
                                        }
                                    });
                                    console.log('Mobility Officer && Facility Suppervisor');
                                }
                                else if (userRoleName.includes('Mobility Officer') && userRoleName.includes('Facility Officer') && !userRoleName.includes('Facility Suppervisor')) {
                                    debugger;
                                    console.log('Mobility Officer && Facility Officer && !Facility Suppervisor');
                                    res.data.forEach((item, index) => {
                                        if (item.name === "Setting") {
                                            item.children.splice(1, 4);
                                        }
                                    });
                                }
                                else if (userRoleName.includes('Mobility Officer') && !userRoleName.includes('Facility Officer') && !userRoleName.includes('Facility Suppervisor')) {
                                    res.data = res.data.slice(1);
                                }
                                else if (userRoleName.includes('Facility Officer') && !userRoleName.includes('Mobility Officer')) {
                                    res.data.splice(1, 2);
                                    res.data.forEach((item, index) => {
                                        if (item.name === "Setting") {
                                            item.children.splice(1, 4);
                                        }
                                    });
                                }
                                else if (userRoleName.includes('Facility Suppervisor') && !userRoleName.includes('Mobility Officer')) {
                                    res.data.splice(1, 1);
                                    res.data.forEach((item, index) => {
                                        if (item.name === "Setting") {
                                            item.children.splice(2, 3);
                                        }
                                    });
                                }
                                else if (!userRoleName.includes('Mobility Officer') && !userRoleName.includes('Facility Officer') && !userRoleName.includes('Facility Suppervisor')) {
                                    res.data = [];
                                }
                            }
                        }
                    }
                }
                // 二开 end
                //二开开始 Contract Renewal 判断是否显示Report目录树
                if (this.appCode === "ContractExtensionSystem") {
                    // const hrbpPamams = {
                    //   code: 'hrbpTasks'
                    // }
                    // const srhrmPamams = {
                    //   code: 'srhrmTasks'
                    // }
                    // const sccPamams = {
                    //   code: 'sccTasks'
                    // }
                    const ContractListRes = yield this.getContractTaskListByRole();
                    // const srhrmRes = await this.getContractTaskListByRole(srhrmPamams)
                    // const sccRes = await this.getContractTaskListByRole(sccPamams)
                    // console.log(hrbpRes, 'hrbpRes', srhrmRes, 'srhrmRes', sccRes, 'sccRes');
                    console.log(ContractListRes, 'ContractListRes');
                    if (user.username !== 'admin') {
                        if (!user.admin) {
                            if (ContractListRes.errcode === 0) {
                                let newList = [];
                                for (let z = 0; z < res.data.length; z++) {
                                    if (res.data[z].name === "My Task List") {
                                        for (let x = 0; x < res.data[z].children.length; x++) {
                                            if (res.data[z].children[x].code === "lmtasks") {
                                                newList.push(res.data[z].children[x]);
                                            }
                                            if (ContractListRes.data.hrbpTasks) {
                                                if (res.data[z].children[x].code === "hrbpTasks") {
                                                    newList.push(res.data[z].children[x]);
                                                }
                                            }
                                            if (ContractListRes.data.srhrmTasks) {
                                                if (res.data[z].children[x].code === "srhrmTasks") {
                                                    newList.push(res.data[z].children[x]);
                                                }
                                            }
                                            if (ContractListRes.data.sccTasks) {
                                                if (res.data[z].children[x].code === "sccTasks") {
                                                    newList.push(res.data[z].children[x]);
                                                }
                                            }
                                        }
                                        res.data[z].children = newList;
                                    }
                                }
                            }
                        }
                        // if(ContractListRes.errcode === 0) {
                        //   if(!ContractListRes.data.hrbpTasks && !ContractListRes.data.sccTasks && !ContractListRes.data.srhrmTasks) {
                        //     debugger
                        //     res.data = res.data.forEach((el:any) => {
                        //       if(el.name === "My Task List") {
                        //         el.children = el.children.filter((item:any) => {
                        //           if(item.code === "lmtasks") {
                        //             return item
                        //           }
                        //         })
                        //       }
                        //     })
                        //   } else if(!ContractListRes.data.hrbpTasks && !ContractListRes.data.sccTasks && ContractListRes.data.srhrmTasks) {
                        //     debugger
                        //     res.data = res.data.filter((el:any) => {
                        //       if(el.name === "My Task List") {
                        //         el.children = el.children.filter((item:any) => {
                        //           item.code === "lmtasks" || item.code === "srhrmTasks"
                        //           // if(item.code === "lmtasks" || item.code === "srhrmTasks") {
                        //           //   return item
                        //           // }
                        //         })
                        //       }
                        //     })
                        //   } else if(!ContractListRes.data.hrbpTasks && ContractListRes.data.sccTasks && !ContractListRes.data.srhrmTasks) {
                        //     debugger
                        //     res.data = res.data.filter((el:any) => {
                        //       if(el.name === "My Task List") {
                        //         el.children = el.children.filter((item:any) => {
                        //           if(item.code === "lmtasks" || item.code === "sccTasks") {
                        //             return item
                        //           }
                        //         })
                        //       }
                        //     })
                        //   } else if(ContractListRes.data.hrbpTasks && !ContractListRes.data.sccTasks && !ContractListRes.data.srhrmTasks) {
                        //     debugger
                        //     // res.data.forEach((el:any) => {
                        //     //   if(el.name === "My Task List") {
                        //     //     el.children = el.children.filter((item:any,index:any) => {
                        //     //       item.code === "lmtasks" || item.code === "hrbpTasks"
                        //     //       // if(item.code !== "lmtasks" || item.code !== "hrbpTasks") {
                        //     //       //   el.children.splice(index, 1);
                        //     //       //   index--;
                        //     //       //   // return item
                        //     //       // }
                        //     //     })
                        //     //   }
                        //     // })
                        //     const list = ["lmtasks", "hrbpTasks"]
                        //     for(let z = 0; z < res.data.length; z++) {
                        //       if(res.data[z].name === "My Task List") {
                        //         for(let x = 0; x < res.data[z].children.length; x++) {
                        //           if(!list.includes(res.data[z].children[x].code)) {
                        //             res.data[z].children.splice(x, 1);
                        //             x--;
                        //           }
                        //         }
                        //       }
                        //     }
                        //     console.log(res.data, 'res.data');
                        //     debugger
                        //   } else if(!ContractListRes.data.hrbpTasks && ContractListRes.data.sccTasks && ContractListRes.data.srhrmTasks) {
                        //     debugger
                        //     res.data = res.data.filter((el:any) => {
                        //       if(el.name === "My Task List") {
                        //         el.children = el.children.filter((item:any) => {
                        //           if(item.code !== "hrbpTasks") {
                        //             return item
                        //           }
                        //         })
                        //       }
                        //     })
                        //   } else if(ContractListRes.data.hrbpTasks && !ContractListRes.data.sccTasks && ContractListRes.data.srhrmTasks) {
                        //     debugger
                        //     res.data = res.data.filter((el:any) => {
                        //       if(el.name === "My Task List") {
                        //         el.children = el.children.filter((item:any) => {
                        //           if(item.code !== "sccTasks") {
                        //             return item
                        //           }
                        //         })
                        //       }
                        //     })
                        //   }else if(ContractListRes.data.hrbpTasks && ContractListRes.data.sccTasks && !ContractListRes.data.srhrmTasks) {
                        //     debugger
                        //     res.data = res.data.filter((el:any) => {
                        //       if(el.name === "My Task List") {
                        //         el.children = el.children.filter((item:any) => {
                        //           if(item.code !== "srhrmTasks") {
                        //             return item
                        //           }
                        //         })
                        //       }
                        //     })
                        //   }
                        // }
                    }
                    let Contractres = yield axios.get(`/api/contract/getContractByRole`);
                    if (Contractres.errcode === 0) {
                        if (Contractres.data) {
                        }
                        else {
                            res.data = res.data.filter((el) => el.code !== "31d3a551b475410fb136e282fde0c2f5");
                        }
                    }
                    let userInfo = JSON.parse(window.sessionStorage.getItem('user'));
                    if (userInfo.admin) {
                    }
                    else {
                        res.data = res.data.filter((el) => el.code !== "ManagerTasks");
                    }
                }
                //二开结束 Contract Renewal 判断是否显示目录树
                if (!Array.isArray(res.data)) {
                    return;
                }
                debugger;
                // this.AppList = res.data;
                this.AppList = res.data.map((i) => {
                    i = this.initData(i);
                    return i;
                });
                //当分组下没有可见模型时不显示分组
                this.AppList = this.AppList.filter((x) => {
                    if (x.type === "Folder") {
                        return Array.isArray(x.children) && x.children.length > 0;
                    }
                    else {
                        return x;
                    }
                });
                //二开开始
                let homepage = {
                    appName: null,
                    appName_i18n: null,
                    children: null,
                    // code: this.appCode,
                    code: 'homepage',
                    deleted: false,
                    icon: "h-icon-all-warehouse-o",
                    mobileAble: true,
                    mobileUrl: "",
                    modelType: "LIST",
                    name: "homepage",
                    name_i18n: '{"en":"Homepage"}',
                    openMode: "VUE_MODE",
                    pcAble: true,
                    pcUrl: `/application/${this.appCode}/homepage`,
                    // pcUrl: `/application/Apps/homepage`,
                    published: null,
                    remarks: null,
                    scopedSlots: { title: "title" },
                    sortKey: 2,
                    type: "Page",
                };
                this.AppList.unshift(homepage);
                let userInfo = JSON.parse(window.sessionStorage.getItem('user'));
                setTimeout(() => {
                    debugger;
                    if (!this.isShowApproval && !userInfo.permissions.length) {
                        for (let i = 0; i < this.AppList.length; i++) {
                            if (this.AppList[i].code === "TAPermissionApproval" || this.AppList[i].code === "TAMasterData") {
                                this.AppList.splice(i, 1);
                                i--;
                            }
                        }
                    }
                }, 1500);
                if (this.appCode === 'hr_setting_portal') { // 增加表单的判断
                    let isSSC = yield axios.get(`/api/HRSetting/isSSC?userId=${userInfo.id}`);
                    let isHRAdmin = yield axios.get(`/api/HRSetting/isAdmin?userId=${userInfo.id}`);
                    if (isSSC && !userInfo.permissions.length) {
                        this.AppList.forEach((item, index) => {
                            if (item.appCode === 'hr_setting_portal') {
                                item.children = item.children.filter((k) => {
                                    if (k.code !== "SRHRM_Setting") {
                                        return k;
                                    }
                                });
                            }
                        });
                    }
                    else {
                        let HRParams1 = {
                            filters: [],
                            mobile: false,
                            page: 0,
                            queryCode: "SRHRM_Setting",
                            schemaCode: "SRHRM_Setting",
                            size: 20
                        };
                        let HRData1 = yield axios.post(`/api/runtime/query/list`, HRParams1);
                        if (HRData1.errcode === 0 && !isHRAdmin) {
                            if (HRData1.data.content.length) {
                                let HRParams = {
                                    filters: [{ propertyCode: "88888", propertyType: 0, propertyValue: "", propertyValueName: "" }],
                                    mobile: false,
                                    page: 0,
                                    queryCode: "SRHRM_Setting",
                                    schemaCode: "SRHRM_Setting",
                                    size: 20
                                };
                                let HRData = yield axios.post(`/api/runtime/query/list`, HRParams);
                                if (HRData.errcode === 0) {
                                    if (!HRData.data.content.length && !userInfo.permissions.length) {
                                        this.AppList.forEach((item, index) => {
                                            if (item.appCode === 'hr_setting_portal') {
                                                item.children = item.children.filter((k) => {
                                                    if (k.code !== "SRHRM_Setting") {
                                                        return k;
                                                    }
                                                });
                                            }
                                        });
                                    }
                                }
                            }
                            else {
                                this.AppList.forEach((item, index) => {
                                    if (item.appCode === 'hr_setting_portal') {
                                        item.children = item.children.filter((k) => {
                                            if (k.code !== "hrbp_Information") {
                                                if (k.code !== "SRHRM_Setting") {
                                                    return k;
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        // let HRParams = {
                        //   filters:[{propertyCode:"88888",propertyType:0,propertyValue:"",propertyValueName:""}],
                        //   mobile:false,
                        //   page:0,
                        //   queryCode:"SRHRM_Setting",
                        //   schemaCode:"SRHRM_Setting",
                        //   size:20
                        // }
                        // let HRData:any = await axios.post(`/api/runtime/query/list`,HRParams)
                        // if(HRData.errcode === 0){
                        //   if(!HRData.data.content.length && !userInfo.permissions.length){
                        //     this.AppList.forEach((item ,index)=>{
                        //       if(item.appCode === 'hr_setting_portal'){
                        //         item.children = item.children.filter((k)=>{
                        //           if(k.code !== "hrbp_Information"){
                        //             if(k.code !== "SRHRM_Setting"){
                        //               return k
                        //             }
                        //           }
                        //         })
                        //       }
                        //     })
                        //   }
                        // }
                    }
                }
                // 二开 sf_usb_unlock_applicati表单查看权限 开始
                if (this.appCode === "it_Application") {
                    let userInfo = JSON.parse(sessionStorage.getItem('user'));
                    if (!userInfo.permissions.length) { // 如果不是管理员
                        let res = yield axios.get(`/api/organization/user/info?id=${userInfo.id}`);
                        if (res.errcode === 0) {
                            let userExtAttrModels = res.data.userExtAttrModels;
                            let mapVal = '';
                            let filterArr = ['SF', 'HIL', 'IB'];
                            userExtAttrModels.forEach((item) => {
                                if (item.mapKey === 'LegalEntity') {
                                    mapVal = item.mapVal;
                                }
                            });
                            if (!filterArr.includes(mapVal)) {
                                this.AppList.forEach((item, index) => {
                                    if (item.children) {
                                        item.children = item.children.filter((k) => {
                                            if (k.code !== "sf_usb_unlock_applicati") {
                                                return k;
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                }
                //二开结束
                //处理是初始化页面
                if (this.appPath) {
                    let url = this.appPath;
                    let code = "";
                    try {
                        //  code = url.split('/').pop().split('?')[0];
                        code = url.split("&code=").pop().split("&")[0];
                    }
                    catch (error) { }
                    this.findItem(this.AppList, code);
                    if (this.isData) {
                        this.defaultKey = [this.isData.code];
                        this.onSelect(this.defaultKey, this.isData, true);
                    }
                    else {
                        try {
                            code = url.split("/").pop().split("?")[0];
                        }
                        catch (error) { }
                        this.findItem(this.AppList, code);
                        if (this.isData) {
                            this.defaultKey = [this.isData.code];
                            this.onSelect(this.defaultKey, this.isData, true);
                        }
                        else {
                            this.defaultKey = Array.isArray(this.AppList[0].children)
                                ? [this.AppList[0].children[0].code]
                                : [this.AppList[0].code];
                            this.onSelect(this.defaultKey, this.AppList[0], true);
                        }
                    }
                }
                else {
                    this.defaultKey = this.modalCode
                        ? [this.modalCode]
                        : Array.isArray(this.AppList[0].children)
                            ? this.AppList[0].children[0].children
                                ? [this.AppList[0].children[0].children[0].code]
                                : [this.AppList[0].children[0].code]
                            : [this.AppList[0].code];
                    this.findItem(this.AppList, this.defaultKey[0]);
                    this.onSelect(this.defaultKey, this.isData, true);
                }
                let data = {
                    children: [],
                    title: "",
                    key: "",
                    scopedSlots: {},
                };
                //处理搜索树形数据
                this.treeData = this.getChildrenTreeData(this.AppList);
                // (this.$refs.mychild as any).onReset();ant
            }
        });
    }
    initData(item) {
        item.scopedSlots = {
            title: "title",
        };
        if (item.children && item.children.length) {
            item.children = item.children.map((i) => {
                i = this.initData(i);
                return i;
            });
        }
        return item;
    }
    treeShowChange(val) {
        this.searchFocus = val;
        if (val) {
            // (this.$refs.mychild as any).init();
        }
    }
    /**
     * 树形控件
     */
    onSelect(keys, e, init = false) {
        this.treeShow = false;
        // console.log(keys,e,this.defaultKey)
        let item;
        if (!init) {
            // if(e.selected){
            //   item = e.node.dataRef
            // } else {
            item = e.node.dataRef;
            if (this.routeKey.includes(item.code) &&
                item.children &&
                item.children.length) {
                //length可能不存在导致报错，
                this.routeKey = this.routeKey.filter((i) => {
                    return i !== item.code;
                });
            }
            else if (item.code === this.defaultKey[0]) {
                return;
            }
            else {
                this.routeKey = this.routeKey.filter((i) => {
                    return i !== this.defaultKey[0];
                });
                this.routeKey.push(item.code);
            }
            // }
        }
        else {
            if (e) {
                if (e.children) {
                    this.onSelect(keys, e.children[0], true);
                    return;
                }
                item = e;
            }
            else {
                if (this.AppList.length > 0 && this.AppList[0]) {
                    let nodeList = this.AppList[0].children;
                    if (nodeList && nodeList.length > 0) {
                        this.onSelect(keys, nodeList[0], true);
                        return;
                    }
                    item = this.AppList[0];
                }
            }
        }
        if (!item || item.children)
            return;
        // if (!Array.isArray(keys) || keys.length < 1) return;
        // let item;
        // this.AppList.some((node: any) => {
        //   const res =
        //     node.children &&
        //     node.children.find((child: any) => keys.includes(child.code));
        //   if (res) {
        //     item = res;
        //     return true;
        //   }
        //   const res2 = keys.includes(node.code);
        //   if (res2) {
        //     item = node;
        //     return true;
        //   }
        //   return false;
        // });
        // if (item.children) return; //点击了目录
        this.routeName = [];
        this.findItem(this.AppList, item.code);
        this.setAppNameList([this.appName, ...this.routeName]);
        if (item) {
            this.setApplicationPageTitle(item);
            if (item.type === "BizModel") {
                if (this.$route.params.appCode !== item.appCode ||
                    this.$route.params.schemaCode !== item.code ||
                    this.$route.query.code !== item.code) {
                    if (item.appCode === "nfq007" && item.code === "liucheng0001") {
                        this.$router
                            .push({
                            name: "testApplication",
                            params: {
                                appCode: item.appCode,
                                schemaCode: item.code,
                            },
                            query: {
                                parentId: item.parentId,
                                code: item.code,
                                openMode: item.openMode,
                                pcUrl: item.pcUrl,
                                queryCode: this.queryCode,
                            },
                        })
                            .catch((err) => {
                            err;
                        });
                    }
                    else {
                        debugger;
                        this.$router
                            .push({
                            name: "applicationList",
                            params: {
                                appCode: item.appCode,
                                schemaCode: item.code,
                            },
                            query: {
                                parentId: item.parentId,
                                code: item.code,
                                openMode: item.openMode,
                                pcUrl: item.pcUrl,
                                queryCode: this.queryCode,
                                // majia 二开开始
                                HomePageMessage: this.$route.query.HomePageMessage ? this.$route.query.HomePageMessage : ''
                                //二开结束
                            },
                        })
                            .catch((err) => {
                            err;
                        });
                    }
                }
            }
            else if (item.type === "Report") {
                if (this.$route.params.appCode !== item.appCode ||
                    this.$route.params.reportCode !== item.code ||
                    this.$route.query.code !== item.code) {
                    this.$router
                        .push({
                        name: "applicationReport",
                        params: {
                            appCode: item.appCode,
                            reportCode: item.code,
                        },
                        query: {
                            parentId: item.parentId,
                            code: item.code,
                            openMode: item.openMode,
                            pcUrl: item.pcUrl,
                            queryCode: item.queryCode,
                        },
                    })
                        .catch((err) => {
                        err;
                    });
                }
            }
            else if (item.pcUrl && item.pcUrl.includes("workflow-design")) {
                // 流程设计,则新开
                const { href } = this.$router.resolve({
                    name: "design",
                    query: {
                        parentId: item.parentId,
                        code: item.code,
                        openMode: item.openMode,
                    },
                });
                window.open(href, "_blank");
            }
            else if (item.pcUrl) {
                if (this.$route.query.code !== item.code) {
                    if (item.openMode === "RECENT_PAGE_MODE") {
                        console.log(item, "menu");
                        this.$router
                            .push({
                            name: "applicationDefine",
                            params: {
                                url: item.pcUrl,
                            },
                            query: {
                                parentId: item.parentId,
                                code: item.code,
                                openMode: item.openMode,
                                pcUrl: item.pcUrl,
                                queryCode: item.queryCode,
                            },
                        })
                            .catch((err) => {
                            err;
                        });
                    }
                    else if (item.openMode === "NEW_PAGE_MODE") {
                        window.open(item.pcUrl);
                    }
                    else {
                        this.$router
                            .push({
                            path: item.pcUrl,
                            query: {
                                parentId: item.parentId,
                                code: item.code,
                                openMode: item.openMode,
                                pcUrl: item.pcUrl,
                                queryCode: item.queryCode,
                            },
                        })
                            .catch((err) => {
                            err;
                        });
                    }
                }
            }
        }
        this.defaultKey = keys;
        // console.log(this.defaultKey)
    }
    /**
     * 搜索树
     */
    /**
     * 发起流程
     */
    startWorkflow() {
        const isAdmin = localStorage.getItem("_isAdmin") === "true";
        if (this.rootAdmin || isAdmin) {
            // 暂时规定admin不能发起流程
            this.$message.warn("admin 不能发起流程");
            return;
        }
        this.$router.push({ name: "startWorkflow" }).catch((err) => {
            err;
        });
    }
    mounted() {
        this.switchMenu();
        // 拖拽功能
        this.$nextTick(() => {
            const dragLine = document.querySelector("#jDragLine");
            let that = this;
            let maxClientWidth;
            let minWidth;
            let maxWidth;
            dragLine.addEventListener("mousedown", (e) => {
                maxClientWidth = document.body.clientWidth / 3;
                minWidth = that.dragWidth - 8;
                maxWidth = that.dragWidth + 8;
                document.body.setAttribute("unselectable", "on");
                document.body.setAttribute("onselectstart", "return false;");
                if (e.clientX >= minWidth && e.clientX <= maxWidth) {
                    document.onmousemove = function (ev) {
                        // 收缩的时候不允许拖拽
                        if (that.isShow)
                            return;
                        that.dragWidth = ev.clientX;
                        if (ev.clientX > maxClientWidth) {
                            that.dragWidth = maxClientWidth;
                        }
                        else if (ev.clientX < that.startX) {
                            that.dragWidth = that.startX;
                        }
                        common.utils.Bus.$emit("resize");
                    };
                    document.onmouseup = function () {
                        document.body.removeAttribute("unselectable");
                        document.body.removeAttribute("onselectstart");
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                }
            }, false);
        });
        const curDom = this.$refs.slider;
        curDom.$el.addEventListener("transitionend", this.transitionendEvent, false);
        if (this.$route.fullPath.includes("/workflow-center/start-workflow")) {
            this.isActive = true;
        }
        else {
            this.isActive = false;
        }
    }
    getEmployeeGroup() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.GetEmployeeGroupInfo();
            const employeeGroupList = ["b", "c", "i", "j"];
            if (res.errcode === 0) {
                let dimission = res.data ? res.data.toLowerCase() : '';
                if (!employeeGroupList.includes(dimission)) {
                    this.isEmployeeGroup = false;
                }
                else {
                    this.isEmployeeGroup = true;
                }
            }
            else {
                this.isEmployeeGroup = false;
            }
        });
    }
    transitionendEvent(e) {
        if (e.propertyName === "width") {
            common.utils.Bus.$emit("resize");
        }
    }
    beforeDestroy() {
        const curDom = this.$refs.slider;
        curDom.$el.removeEventListener("transitionend", this.transitionendEvent, false);
    }
    // 切换菜单
    switchMenu() {
        if (!this.$route)
            return;
        const { fullPath } = this.$route;
        const isWorkflowCenterRoute = fullPath.includes("workflow-center");
        const isApplicationRoute = fullPath.includes("application");
        if (isWorkflowCenterRoute) {
            this.curMenu = "WorkflowCenterMenu";
        }
        else if (isApplicationRoute) {
            this.curMenu = "AppsMenu";
            this.menuTitle = this.asideTitle;
            this.menuTitleI18n = this.asideTitleI18n;
        }
    }
    hideMenu() {
        this.isShow = !this.isShow;
        if (this.isShow) {
            this.dragWidth = this.isAppList ? 0 : 64;
            this.startX = this.isAppList ? 0 : 64;
        }
        else {
            this.dragWidth = this.isAppList ? 250 : 240;
            this.startX = this.isAppList ? 250 : 240;
        }
        this.setHideMenu(this.isShow);
    }
    onRouterChange() {
        debugger;
        this.switchMenu();
    }
    // 二开survey路由监听
    myRouterChange(to, from) {
        debugger;
        if (to.query.tag === 'tag') {
            this.routeKey = ["bcfc4868ad744317a5daa29b2a1a1125", "my_survey_result", "bcfc4868ad744317a5daa29b2a1a1125", "bcfc4868ad744317a5daa29b2a1a1125", "my_survey_result"];
            this.defaultKey = ["my_survey_result"];
        }
        const isAdmin = localStorage.getItem("_isAdmin") === "true";
        const that = this;
        if (!(this.rootAdmin || isAdmin)) {
            let userInfo = JSON.parse(window.sessionStorage.getItem('user'));
            let url = `/api/runtime/app/checkAppPermission?appCode=${this.appCode}&userId=${userInfo.id}`;
            listApi.GetAppGroupInfo(url).then(res => {
                if (res.errcode === 0 && !res.data) {
                    that.$router.replace('/authorityError');
                    // Modal.warning({
                    //   title: 'Warning',
                    //   content: "You don't have permission. Please contact the administrator!",
                    //   okText: 'CLOSE',
                    //   onOk() {
                    //     // that.$router.replace('/workbench-center/workbench')
                    //     that.$router.replace('/authorityError');
                    //   },
                    // });
                }
            });
        }
        // if(to.path.indexOf('/application/working_flexible/') > -1 && to.params.appCode === 'working_flexible'){
        //   listApi.GetEmployeeGroupInfo().then(res=>{
        //     const employeeGroupList = ["b","c","i","j"]
        //     if (res.errcode === 0) {
        //       let dimission = res.data ? res.data.toLowerCase() : '';
        //       if (!employeeGroupList.includes(dimission) && !(this.rootAdmin || isAdmin)) {
        //         Modal.warning({
        //           title: 'Warning',
        //           content: "You don't have permission. Please contact the administrator!",
        //           okText: 'CLOSE',
        //           onOk() {
        //             that.$router.replace('/workbench-center/workbench')
        //           },
        //         });
        //       }
        //     } else {
        //       Modal.warning({
        //         title: 'Warning',
        //         content: "You don't have permission. Please contact the administrator!",
        //         okText: 'CLOSE',
        //         onOk() {
        //           that.$router.replace('/workbench-center/workbench')
        //         },
        //       });
        //     }
        //   });
        // }
        // if(to.path.indexOf('/application/certificate/') > -1 && to.params.appCode === 'certificate'){
        //   listApi.GetCertificateGroupInfo().then(res=>{
        //     if (res.errcode === 0 && !res.data) {
        //       Modal.warning({
        //         title: 'Warning',
        //         content: "You don't have permission. Please contact the administrator!",
        //         okText: 'CLOSE',
        //         onOk() {
        //           that.$router.replace('/workbench-center/workbench')
        //         },
        //       });
        //     }
        //   });
        // }
        // if(to.path.indexOf('/application/WIT_Authorization/') > -1  && to.params.appCode === 'WIT_Authorization'){
        //   const user:any = JSON.parse((window as any).sessionStorage.getItem('user'))
        //   listApi.getUserInfo(user.id).then(res=>{
        //     if (res.errcode === 0) {
        //       let persarea = res.data.userExtAttrModels.filter(item=>item.code === 'persarea')[0].mapVal;
        //       if(!(persarea === 'CN01' || persarea === 'CN02' || this.rootAdmin || isAdmin)){
        //         if(!user.roleName.includes('WIT user')){
        //           Modal.warning({
        //             title: 'Warning',
        //             content: "You don't have permission. Please contact the administrator!",
        //             okText: 'CLOSE',
        //             onOk() {
        //               that.$router.replace('/workbench-center/workbench')
        //             },
        //           });
        //         }
        //       }
        //     } else {
        //       Modal.warning({
        //         title: 'Warning',
        //         content: "You don't have permission. Please contact the administrator!",
        //         okText: 'CLOSE',
        //         onOk() {
        //           that.$router.replace('/workbench-center/workbench')
        //         },
        //       });
        //     }
        //   });
        // }
    }
    // 二开结束
    onAsideTitleChange(v) {
        if (v) {
            this.menuTitle = v;
        }
    }
    onAsideTitleI18nChange(v) {
        if (v) {
            this.menuTitleI18n = v;
        }
    }
};
tslib_1.__decorate([
    WorkflowCenterModule.State("asideTitle")
], Aside.prototype, "asideTitle", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.State("asideTitleI18n")
], Aside.prototype, "asideTitleI18n", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setIsAppList")
], Aside.prototype, "setIsAppList", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAppNameList")
], Aside.prototype, "setAppNameList", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAppChange")
], Aside.prototype, "setAppChange", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.State("appCode")
], Aside.prototype, "appCode", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.State("modalCode")
], Aside.prototype, "modalCode", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.State("appChange")
], Aside.prototype, "appChange", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.State("appPath")
], Aside.prototype, "appPath", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setHideMenu")
], Aside.prototype, "setHideMenu", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setApplicationPageTitle")
], Aside.prototype, "setApplicationPageTitle", void 0);
tslib_1.__decorate([
    Watch("isAppList", {
        immediate: true,
    })
], Aside.prototype, "getWidth", null);
tslib_1.__decorate([
    Watch("appValueChange", {
        immediate: true,
    })
], Aside.prototype, "initAppData", null);
tslib_1.__decorate([
    Watch("$route")
], Aside.prototype, "handler", null);
tslib_1.__decorate([
    Watch("$route")
], Aside.prototype, "onRouterChange", null);
tslib_1.__decorate([
    Watch("$route")
], Aside.prototype, "myRouterChange", null);
tslib_1.__decorate([
    Watch("asideTitle")
], Aside.prototype, "onAsideTitleChange", null);
tslib_1.__decorate([
    Watch("asideTitleI18n")
], Aside.prototype, "onAsideTitleI18nChange", null);
Aside = tslib_1.__decorate([
    Component({
        name: "Aside",
        components: {
            // 二开开始
            HomePage,
            //二开结束
            ALayoutSider: Layout.Sider,
            WorkflowCenterMenu,
            AppsMenu,
            ATooltip: Tooltip,
            ATree: Tree,
            ATreeNode: Tree.TreeNode,
            AInputSearch: Input.Search,
            APopover: Popover,
            ADirectoryTree: Tree.DirectoryTree,
            SearchTree,
            AIcon: Icon,
            ATreeSelect: TreeSelect,
            ATreeSelectNode: TreeSelect.TreeNode,
            Modal,
        },
    })
], Aside);
export default Aside;
